var moment = require('moment')
var dateutils = require('./dateutils')
var firestoretable = require('./firestoretable')
const state = {
  all: [],
  headers: [
    { key: 'createdDate', label: 'Created Date' },
    { key: 'claimEmail', label: 'Customer Email' },
    { key: 'accountNumber', label: 'Account No.' },
    { key: 'companyName', label: 'Company' },
    { key: 'campaignDocId', label: 'Campaign ID' },
    { key: 'claimMode', label: 'Claim Mode' },
    { key: 'status', label: 'Status' },
    { key: 'rewardSummary', label: 'Reward' },
    { key: 'rewardType', label: 'Reward Type' },
    { key: 'totalReward', label: 'Money Value' },
    { key: 'invoiceSummary', label: 'Invoice(s)' },
    { key: 'requestedClaimSubtypes', label: 'Requested Qty' },
    { key: 'pairingClaimSubtypes', label: 'Pairing Qty' },
    { key: 'remainingDrawTimes', label: 'Draws Left' },
    { key: 'drawRecords', label: 'Draw Records' },
    { key: 'updatedDate', label: 'Updated Date' }
  ],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  calculatedObjects: [],
  calculatedTotalClaimedPrizeMoney: 0,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

function normaliseRewardDetails (claimData) {
  let rewardDetails = {
    moneyTotal: 0,
    labels: [],
    nonMoneyLabels: [],
    types: []
  }

  if (claimData.drawRecords && claimData.drawRecords.length > 0) {
    claimData.drawRecords.forEach(drawRecord => {
      let rewardValue = Number(drawRecord.rewardValue || drawRecord.reward || 0)
      let rewardType = (drawRecord.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER')).toUpperCase()
      let rewardLabel = drawRecord.rewardLabel || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward')

      if (rewardType === 'MONEY') {
        rewardDetails.moneyTotal += rewardValue
      } else {
        rewardDetails.nonMoneyLabels.push(rewardLabel)
      }
      rewardDetails.labels.push(rewardLabel)
      if (rewardDetails.types.indexOf(rewardType) === -1) {
        rewardDetails.types.push(rewardType)
      }
    })
  } else {
    let rewardValue = Number(claimData.prizeMoney != null && claimData.prizeMoney !== '' ? claimData.prizeMoney : claimData.totalReward)
    let rewardType = rewardValue > 0 ? 'MONEY' : (claimData.rewardType || 'VOUCHER')
    rewardDetails.moneyTotal = rewardType === 'MONEY' ? rewardValue : 0
    rewardDetails.labels.push(claimData.rewardSummary || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward'))
    if (rewardType !== 'MONEY') {
      rewardDetails.nonMoneyLabels.push(claimData.rewardSummary || 'Reward')
    }
    rewardDetails.types.push(rewardType)
  }

  rewardDetails.summary = rewardDetails.labels.join(', ')
  rewardDetails.nonMoneySummary = rewardDetails.nonMoneyLabels.join(', ')
  rewardDetails.typeSummary = rewardDetails.types.join(', ')
  return rewardDetails
}

function formatDrawRecords (drawRecords) {
  let drawRecordsString = ''
  drawRecords.forEach(drawRecord => {
    if (drawRecordsString.length > 0) {
      drawRecordsString += ','
    }
    let drawDate = moment(dateutils.toJsDate(drawRecord.drawDate))
    let rewardValue = Number(drawRecord.rewardValue || drawRecord.reward || 0)
    let rewardLabel = drawRecord.rewardLabel || (rewardValue > 0 ? 'RM ' + rewardValue : 'Reward')
    let rewardType = drawRecord.rewardType || (rewardValue > 0 ? 'MONEY' : 'VOUCHER')
    drawRecordsString += '[drawTimes=' + drawRecord.drawTimes + ', reward=' + rewardLabel + ', type=' + rewardType + ', drawDate=' + drawDate.format('DD/MMM/YYYY hh:mm:ss a') + ']'
  })
  return drawRecordsString
}

function formatClaimSubtypes (subtypes) {
  if (!Array.isArray(subtypes) || subtypes.length === 0) {
    return '-'
  }

  return subtypes.map(eachType => {
    let quantity = Number(eachType.claimQuantity || 0)
    return 'Subtype: ' + (eachType.docId || eachType.subTypeDocId || '-') + '\nLenses: ' + quantity
  }).join(', ')
}

function getPairingClaimSubtypes (claimData) {
  return claimData.pairingClaimSubtypes || claimData.pairedClaimSubtypes || []
}

function decorateClaimRow (rowObject, claimData) {
  let requestedTaxInvoice = claimData.requestedTaxInvoice || ''
  let pairingTaxInvoice = claimData.pairingTaxInvoice || claimData.pairedTaxInvoice || ''
  let isPaired = claimData.paired === true || pairingTaxInvoice.length > 0

  rowObject.claimMode = isPaired ? 'Paired claim' : 'Single invoice'
  rowObject.invoiceSummary = isPaired
    ? requestedTaxInvoice + ' + ' + pairingTaxInvoice
    : requestedTaxInvoice
  rowObject.pairingTaxInvoice = pairingTaxInvoice
  rowObject.pairedTaxInvoice = pairingTaxInvoice
  rowObject.requestedClaimSubtypes = formatClaimSubtypes(claimData.requestedClaimSubtypes)
  rowObject.pairingClaimSubtypes = formatClaimSubtypes(getPairingClaimSubtypes(claimData))
  rowObject.pairedClaimSubtypes = rowObject.pairingClaimSubtypes
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    console.log('total rows: ' + state.totalRows)
  },
  selectTableRow: function (state, docId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info'
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
    console.log('show loading animation: ' + show)
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      if (typeof eachHeader === 'string') {
        extraHeaders.push({
          key: eachHeader,
          sortable: true
        })
      } else {
        extraHeaders.push(Object.assign({ sortable: true }, eachHeader))
      }
    }
    return extraHeaders
  }
}

const actions = {
  showAllClaims (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.commit('toggleDisabledPagination', true)

    let queryParameters = {
      collectionName: 'claims',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: payload.orderBys,
      orderByDirection: 'asc',
      orderByFlippedDirection: 'desc'
    }

    let docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters)

    // firestoretable.queryCollection(docQuery, context, queryParameters, false)

    // if (context.state.currentPage === 1) {
    // let docQuery = context.rootState.firestoreDB.collection('claims')
    //   .orderBy(payload.orderBys)
    //   .limit(context.state.rowsPerPage)
    docQuery.get().then(function (querySnapshot) {
      let index = 0
      let jumpIndex = 0
      let docIndex = 0
      querySnapshot.forEach(function (doc) {
        docIndex++
        if (queryParameters.jumpedPage && jumpIndex < (queryParameters.jumpedLimit - context.state.rowsPerPage)) {
          jumpIndex++
          return
        }
        if (index === 0) {
          context.state.lastShown.firstRowShown = doc
        }
        index++
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let rowObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('-------> eachProp: ' + eachProp)
          if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            rowObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            rowObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'requestedClaimSubtypes' || propName === 'pairedClaimSubtypes' || propName === 'pairingClaimSubtypes') {
            rowObject[propName] = formatClaimSubtypes(doc.data()[eachProp])
          } else if (propName === 'drawRecords') {
            rowObject[propName] = formatDrawRecords(doc.data()[eachProp])
          } else {
            rowObject[propName] = doc.data()[eachProp]
          }
        }
        let rewardDetails = normaliseRewardDetails(documentData)
        rowObject.totalReward = rewardDetails.moneyTotal
        rowObject.rewardSummary = rewardDetails.summary
        rowObject.rewardType = rewardDetails.typeSummary
        decorateClaimRow(rowObject, documentData)
        // after we got the email, run a subquery to retrieve HOYA account number
        context.rootState.firestoreDB.collection('users').doc(rowObject.claimEmail)
          . get()
          .then(function (userdoc) {
            if (userdoc.exists) {
              // console.log('email: ' + invoiceObject.claimEmail + ' accountNumber: ' + userdoc.data().accountNumber)
              rowObject.accountNumber = userdoc.data().accountNumber
              rowObject.companyName = userdoc.data().companyName
            }
            rowObject.docId = doc.id
            rowObject._rowVariant = ''
            console.log('flippedSorting: ' + queryParameters.flippedSorting)
            if (queryParameters.flippedSorting === true) {
              queryParameters.flippedResult.push(rowObject)
            } else {
              context.state.all.push(rowObject)
            }
            context.state.lastShown.lastShownPage = context.state.currentPage
            context.state.lastShown.lastRowShown = doc
            context.commit('toggleDisabledPagination', false)

            console.log('docIndex: ' + docIndex)
            console.log('querySnapshot.size: ' + querySnapshot.size)
            if (queryParameters.flippedResult.length === querySnapshot.size) {
              if (queryParameters.flippedSorting === true) {
                queryParameters.flippedResult.reverse()
                queryParameters.flippedResult.forEach(function (value) {
                  context.state.all.push(value)
                })
                let tempHolder = context.state.lastShown.firstRowShown
                context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown
                context.state.lastShown.lastRowShown = tempHolder
              }
            }
          }).catch(function (err) {
            console.error(err)
            context.commit('toggleDisabledPagination', false)
          })

        // invoiceObject.claimId = doc.id
        // invoiceObject._rowVariant = ''
        // context.state.all.push(invoiceObject)
      })

      context.commit('toggleShowLoadingAnimation', false)
      if (querySnapshot.size === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in claims collection: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      context.commit('toggleDisabledPagination', false)
    })

    // count total rows
    context.rootState.realtimeDb.ref('claims').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount))
      } else {
        let firstQuery = context.rootState.firestoreDB.collection('claims')
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length)
        })
      }
    })
  },
  filterTable: function (context, payload) {
    if (!payload) {
      return
    }
    let haveFilter = false
    for (let i in payload) {
      // console.log('payload[i]:' + payload[i])
      if (payload[i] && payload[i].length > 0) {
        haveFilter = true
      }
    }
    if (!haveFilter) {
      return
    }

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.state.all = []
    context.state.detailAll = []
    context.commit('updateTotalRows', 0)

    let docQuery = context.rootState.firestoreDB.collection('claims')
    for (let i in payload) {
      if (payload[i] && payload[i].length > 0) {
        // console.log('where ' + i + '==' + payload[i])
        docQuery = docQuery.where(i, '==', payload[i])
      }
    }

    if (!docQuery) {
      return
    }

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size)
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'requestedClaimSubtypes' || propName === 'pairedClaimSubtypes' || propName === 'pairingClaimSubtypes') {
            invoiceObject[propName] = formatClaimSubtypes(doc.data()[eachProp])
          } else if (propName === 'drawRecords') {
            invoiceObject[propName] = formatDrawRecords(doc.data()[eachProp])
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        let rewardDetails = normaliseRewardDetails(documentData)
        invoiceObject.totalReward = rewardDetails.moneyTotal
        invoiceObject.rewardSummary = rewardDetails.summary
        invoiceObject.rewardType = rewardDetails.typeSummary
        decorateClaimRow(invoiceObject, documentData)
        // after we got the email, run a subquery to retrieve HOYA account number
        context.rootState.firestoreDB.collection('users').doc(invoiceObject.claimEmail)
          . get()
          .then(function (userdoc) {
            if (userdoc.exists) {
              // console.log('email: ' + invoiceObject.claimEmail + ' accountNumber: ' + userdoc.data().accountNumber)
              invoiceObject.accountNumber = userdoc.data().accountNumber
              invoiceObject.companyName = userdoc.data().companyName
            }
            invoiceObject.docId = doc.id
            invoiceObject._rowVariant = ''
            context.state.all.push(invoiceObject)
          }).catch(function (err) {
            console.error(err)
            invoiceObject.docId = doc.id
            invoiceObject._rowVariant = ''
            context.state.all.push(invoiceObject)
          })
        // invoiceObject.claimId = doc.id
        // invoiceObject._rowVariant = ''
        // context.state.all.push(invoiceObject)
      })
      context.commit('toggleShowLoadingAnimation', false)
      if (querySnapshot.size === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  },
  calculateClaims (context, payload) {
    context.state.calculatedObjects = []
    context.state.calculatedTotalClaimedPrizeMoney = 0
    if (!payload) {
      console.log('no payload')
      return
    }
    // console.log('payload.campaignDocId' + payload.campaignDocId)
    // console.log('payload.claimEmail:' + payload.claimEmail)
    if (!payload.campaignDocId && !payload.claimEmail) {
      console.log('payload empty')
      return
    }
    let docQuery = context.rootState.firestoreDB.collection('claims')

    if (payload.campaignDocId) {
      docQuery = docQuery.where('campaignDocId', '==', payload.campaignDocId)
    }
    if (payload.claimEmail) {
      docQuery = docQuery.where('claimEmail', '==', payload.claimEmail)
    }

    docQuery.get().then(function (querySnapshot) {
      let id = 0
      // console.log('calculate claims total results')
      querySnapshot.forEach(function (doc) {
        if (doc.exists && doc.data().status === 'CLAIMED') {
          let docData = doc.data()
          let rewardDetails = normaliseRewardDetails(docData)
          let claimPrizeMoney = Number(rewardDetails.moneyTotal)
          if (!Number.isFinite(claimPrizeMoney)) {
            console.warn('Invalid claim prize money for claim ' + doc.id + '. Using 0.')
            claimPrizeMoney = 0
          }
          let nonMoneyRewardSummary = rewardDetails.nonMoneySummary
          if (context.state.calculatedObjects.length === 0) {
            let calculatedObject = {
              id: id,
              campaignDocId: docData.campaignDocId,
              claimEmail: docData.claimEmail,
              prizeMoney: claimPrizeMoney,
              rewardSummary: nonMoneyRewardSummary
            }
            context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + Number(calculatedObject.prizeMoney)
            id = id + 1
            context.state.calculatedObjects.push(calculatedObject)
          } else {
            let incremented = false
            for (let i = 0; i < context.state.calculatedObjects.length; i++) {
              let calculatedObject = context.state.calculatedObjects[i]
              if (calculatedObject.campaignDocId === docData.campaignDocId &&
                  calculatedObject.claimEmail === docData.claimEmail) {
                calculatedObject.prizeMoney = Number(calculatedObject.prizeMoney) + claimPrizeMoney
                if (nonMoneyRewardSummary) {
                  calculatedObject.rewardSummary = calculatedObject.rewardSummary
                    ? calculatedObject.rewardSummary + ', ' + nonMoneyRewardSummary
                    : nonMoneyRewardSummary
                }
                incremented = true
                context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + claimPrizeMoney
              }
            }
            if (!incremented) {
              let calculatedObject = {
                id: id,
                campaignDocId: docData.campaignDocId,
                claimEmail: docData.claimEmail,
                prizeMoney: claimPrizeMoney,
                rewardSummary: nonMoneyRewardSummary
              }
              context.state.calculatedTotalClaimedPrizeMoney = Number(context.state.calculatedTotalClaimedPrizeMoney) + Number(calculatedObject.prizeMoney)
              id = id + 1
              context.state.calculatedObjects.push(calculatedObject)
            }
          }
        }
      })
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/claimsstoremodule.js